import PropTypes from 'prop-types'
import { Rating } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import styles from './index.css'

const RatingStar = ({ className, disabled, onRate, value, votes, ...props }) => {
  const onRateStarClick = (_event, { rating }) => onRate(rating)

  return (
    <div className={cn(className, styles.wrapperRate)} {...props}>
      <Rating disabled={disabled} icon="star" maxRating={5} onRate={onRateStarClick} rating={value} />
      {!!votes && <span className={styles.votes}>({votes})</span>}
    </div>
  )
}

RatingStar.propTypes = {
  onRate: PropTypes.func.isRequired,

  className: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.number,
  votes: ChildrenSchema,
}

export default RatingStar
